module.exports = __webpack_public_path__ + "static/media/small_long5.4d2292a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightCardList/images/small/longhaul/small_long5.jpg
// module id = 499
// module chunks = 0